var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showModal
    ? _c(
        "transition",
        {
          attrs: {
            name: "custom-classes-transition",
            "enter-active-class": "animated bounceInLeft",
            "leave-active-class": "animated bounceOutRight",
          },
        },
        [
          _c("div", { staticClass: "detail-modal" }, [
            _c("div", { staticClass: "detail-modal-inner" }, [
              _c("div", { staticClass: "menu" }, [
                _c(
                  "div",
                  {
                    staticClass: "close-show-detail",
                    on: { click: _vm.closeModal },
                  },
                  [
                    _c("eva-icon", {
                      attrs: {
                        name: "close-circle",
                        fill: "#FFF",
                        width: "50",
                        height: "50",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "page-wrap" },
                [
                  _c(
                    "transition",
                    {
                      attrs: {
                        name: "custom-classes-transition",
                        "enter-active-class": "animated flipInY",
                      },
                    },
                    [
                      _c("perfect-scrollbar", { staticClass: "page" }, [
                        _c("section", { staticClass: "page-inner" }, [
                          _c("form", { staticClass: "demand-form" }, [
                            _c("div", { staticClass: "tab-content" }, [
                              _c("div", { staticClass: "tab-section tab-01" }, [
                                _c(
                                  "table",
                                  { staticClass: "table table-bordered" },
                                  [
                                    _c("thead", [
                                      _c("tr", [
                                        _c(
                                          "th",
                                          {
                                            staticClass: "tab-name",
                                            attrs: { colspan: "4" },
                                          },
                                          [_vm._v("職缺")]
                                        ),
                                      ]),
                                    ]),
                                    _c("tbody", [
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "width-15 text-right",
                                          },
                                          [_c("span", [_vm._v("單號")])]
                                        ),
                                        _c("td", { staticClass: "width-35" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.demandDetail.No) +
                                              " "
                                          ),
                                        ]),
                                        _c(
                                          "td",
                                          {
                                            staticClass: "width-15 text-right",
                                          },
                                          [_c("span", [_vm._v("狀態")])]
                                        ),
                                        _c("td", { staticClass: "width-35" }, [
                                          _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$common.manpowerDemandStatusFormatter(
                                                    _vm.demandDetail
                                                      .ManpowerDemandStatus
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_c("span", [_vm._v("名稱")])]
                                        ),
                                        _c("td", { attrs: { colspan: "3" } }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.demandDetail
                                                  .ManpowerDemandName
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [_c("span", [_vm._v("申請日期")])]
                                        ),
                                        _c("td", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$common.dateFormatter(
                                                  _vm.demandDetail.ApplicantTime
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [_c("span", [_vm._v("申請者")])]
                                        ),
                                        _c("td", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.demandDetail.Applicant
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_c("span", [_vm._v("申請部門")])]
                                        ),
                                        _c("td", { attrs: { colspan: "3" } }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.demandDetail
                                                  .DemandDepartment
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [_c("span", [_vm._v("履歷類型")])]
                                        ),
                                        _c("td", [
                                          _vm.demandDetail.ResumeType === "Main"
                                            ? _c("span", [_vm._v("基本履歷")])
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.demandDetail.ResumeType
                                                  )
                                                ),
                                              ]),
                                        ]),
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [_c("span", [_vm._v("招募期限")])]
                                        ),
                                        _c("td", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$common.dateFormatter(
                                                  _vm.demandDetail
                                                    .RecruitmentDeadline
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_c("span", [_vm._v("聘僱合約類別")])]
                                        ),
                                        _c("td", { attrs: { colspan: "3" } }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.demandDetail.ContractType
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_c("span", [_vm._v("招募方式")])]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { colspan: "3" } },
                                          [
                                            _vm.demandDetail
                                              .ManpowerDemandRecruitmentMethod
                                              .length > 0
                                              ? _vm._l(
                                                  _vm.demandDetail
                                                    .ManpowerDemandRecruitmentMethod,
                                                  function (item) {
                                                    return _c(
                                                      "span",
                                                      {
                                                        key: item.RecruitmentMethodGuid,
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.RecruitmentMethodDescription
                                                                ? `其他：${item.RecruitmentMethodDescription}`
                                                                : item.RecruitmentMethod
                                                            )
                                                        ),
                                                        _c("br"),
                                                      ]
                                                    )
                                                  }
                                                )
                                              : [_c("span", [_vm._v("不拘")])],
                                          ],
                                          2
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [_c("span", [_vm._v("職務性質")])]
                                        ),
                                        _c("td", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.demandDetail
                                                  .PositionProperty
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.i18n(
                                                    "Position.PositionName"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("td", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.demandDetail.PositionName
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [_c("span", [_vm._v("需求人數")])]
                                        ),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.demandDetail.DemandNumber
                                            ) + " 人"
                                          ),
                                        ]),
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [_c("span", [_vm._v("預定任職日")])]
                                        ),
                                        _c("td", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$common.dateFormatter(
                                                  _vm.demandDetail.OnBoard
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [_c("span", [_vm._v("年齡")])]
                                        ),
                                        _c("td", [
                                          _vm.demandDetail.AgeRangeWhatever
                                            ? _c("span", [_vm._v(" 不拘 ")])
                                            : _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.demandDetail
                                                        .AgeRangeStart
                                                    ) +
                                                    "～" +
                                                    _vm._s(
                                                      _vm.demandDetail
                                                        .AgeRangeEnd
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                        ]),
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [_c("span", [_vm._v("性別")])]
                                        ),
                                        _c("td", [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.demandDetail.Sex) +
                                              " "
                                          ),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [_c("span", [_vm._v("出差")])]
                                        ),
                                        _c("td", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                !_vm.demandDetail.BusinessTrip
                                                  ? "否"
                                                  : "是"
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [_c("span", [_vm._v("外派")])]
                                        ),
                                        _c("td", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                !_vm.demandDetail.OverseasWork
                                                  ? "否"
                                                  : "是"
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_c("span", [_vm._v("管理責任")])]
                                        ),
                                        _c("td", { attrs: { colspan: "3" } }, [
                                          _vm.demandDetail
                                            .ManagementResponsibility
                                            ? _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.demandDetail
                                                        .ManagementNumber
                                                    ) +
                                                    " 人 "
                                                ),
                                              ])
                                            : _c("span", [_vm._v("無")]),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_c("span", [_vm._v("輪班")])]
                                        ),
                                        _c("td", { attrs: { colspan: "3" } }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                !_vm.demandDetail.Shift
                                                  ? "否"
                                                  : "是"
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_c("span", [_vm._v("班別")])]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { colspan: "3" } },
                                          [
                                            _vm.workingHoursStatus
                                              ? _c("span", [_vm._v("不拘")])
                                              : _vm._l(
                                                  _vm.demandDetail
                                                    .ManpowerDemandWorkShiftType,
                                                  function (item) {
                                                    return _c(
                                                      "span",
                                                      {
                                                        key: item.WorkShiftTypeGuid,
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.WorkShiftType
                                                            )
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          "，時段：" +
                                                            _vm._s(
                                                              item.WorkShiftTypeDescription
                                                            ) +
                                                            " "
                                                        ),
                                                        _c("br"),
                                                      ]
                                                    )
                                                  }
                                                ),
                                          ],
                                          2
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_c("span", [_vm._v("工作地點")])]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { colspan: "3" } },
                                          _vm._l(
                                            _vm.demandDetail.WorkPlace,
                                            function (item, index) {
                                              return _c(
                                                "span",
                                                { key: index },
                                                [
                                                  index > 0
                                                    ? _c("span", [_vm._v("、")])
                                                    : _vm._e(),
                                                  _vm._v(_vm._s(item) + " "),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_c("span", [_vm._v("工作內容")])]
                                        ),
                                        _c("td", { attrs: { colspan: "3" } }, [
                                          _c("pre", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.demandDetail.WorkContent
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_c("span", [_vm._v("說明")])]
                                        ),
                                        _c("td", { attrs: { colspan: "3" } }, [
                                          _c("pre", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.demandDetail.Description
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_c("span", [_vm._v("薪資類型")])]
                                        ),
                                        _c("td", { attrs: { colspan: "3" } }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.demandDetail
                                                  .SalaryTypeDescription
                                                  ? _vm.demandDetail
                                                      .SalaryTypeDescription
                                                  : _vm.demandDetail.SalaryType
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_c("span", [_vm._v("薪資待遇")])]
                                        ),
                                        _c("td", { attrs: { colspan: "3" } }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.demandDetail.SalaryLow
                                              ) +
                                              " ~ " +
                                              _vm._s(
                                                _vm.demandDetail.SalaryHigh
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_c("span", [_vm._v("職務聯絡人")])]
                                        ),
                                        _c("td", { attrs: { colspan: "3" } }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.demandDetail
                                                  .PositionContactor
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_c("span", [_vm._v("聯絡人Email")])]
                                        ),
                                        _c("td", { attrs: { colspan: "3" } }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.demandDetail
                                                  .PositionContactorEmail
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_c("span", [_vm._v("工作經歷")])]
                                        ),
                                        _c("td", { attrs: { colspan: "3" } }, [
                                          _vm.demandDetail
                                            .WorkExperienceWhatever
                                            ? _c("span", [_vm._v("不拘")])
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.demandDetail
                                                      .WorkExperience
                                                  ) + " 年"
                                                ),
                                              ]),
                                        ]),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_c("span", [_vm._v("學歷")])]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { colspan: "3" } },
                                          [
                                            _vm.demandDetail
                                              .EducationDemandWhatever
                                              ? _c("span", [_vm._v(" 不拘 ")])
                                              : _vm._l(
                                                  _vm.demandDetail
                                                    .ManpowerDemandEducationDegree,
                                                  function (item, index) {
                                                    return _c(
                                                      "span",
                                                      {
                                                        key: item.EducationDegreeGuid,
                                                      },
                                                      [
                                                        index > 0
                                                          ? _c("span", [
                                                              _vm._v("、"),
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(
                                                          _vm._s(
                                                            item.EducationDegree
                                                          ) + " "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                          ],
                                          2
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_c("span", [_vm._v("科系")])]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { colspan: "3" } },
                                          [
                                            _vm.demandDetail
                                              .SchoolDepartmentWhatever
                                              ? _c("span", [_vm._v(" 不拘 ")])
                                              : _vm._l(
                                                  _vm.demandDetail
                                                    .ManpowerDemandSchoolDepartment,
                                                  function (item, index) {
                                                    return _c(
                                                      "div",
                                                      { key: index },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "language-title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item.SchoolDepartmentType
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "h6",
                                                          {
                                                            staticStyle: {
                                                              "margin-bottom":
                                                                "12px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item.SchoolDepartment
                                                                    ? item.SchoolDepartment
                                                                    : null
                                                                ) +
                                                                " "
                                                            ),
                                                            item.SchoolDepartmentDescription
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    " ｜科系描述：" +
                                                                      _vm._s(
                                                                        item.SchoolDepartmentDescription
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                          ],
                                          2
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_c("span", [_vm._v("外語")])]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { colspan: "3" } },
                                          [
                                            _vm.languageStatus
                                              ? _c("span", [_vm._v("不拘")])
                                              : _vm._l(
                                                  _vm.demandDetail
                                                    .ManpowerDemandLanguage,
                                                  function (item, index) {
                                                    return _c(
                                                      "div",
                                                      { key: index },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "language-title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.Language
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "h6",
                                                          {
                                                            staticStyle: {
                                                              "margin-bottom":
                                                                "12px",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "language-text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "聽：" +
                                                                    _vm._s(
                                                                      item.Listen
                                                                    )
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v("｜ "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "language-text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "說：" +
                                                                    _vm._s(
                                                                      item.Speak
                                                                    )
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v("｜ "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "language-text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "讀：" +
                                                                    _vm._s(
                                                                      item.Read
                                                                    )
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v("｜ "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "language-text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "寫：" +
                                                                    _vm._s(
                                                                      item.Write
                                                                    )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                          ],
                                          2
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_c("span", [_vm._v("方言")])]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { colspan: "3" } },
                                          [
                                            _vm.dialectStatus
                                              ? _c("span", [_vm._v("不拘")])
                                              : _vm._l(
                                                  _vm.demandDetail
                                                    .ManpowerDemandDialect,
                                                  function (item, index) {
                                                    return _c(
                                                      "div",
                                                      { key: index },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "language-title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.DialectDescription
                                                                  ? item.DialectDescription
                                                                  : item.Dialect
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c("p", [
                                                          _vm._v(
                                                            "程度：" +
                                                              _vm._s(
                                                                item.Degree
                                                              )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  }
                                                ),
                                          ],
                                          2
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_c("span", [_vm._v("駕照")])]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { colspan: "3" } },
                                          [
                                            _vm.driverLicenseStatus
                                              ? _c("span", [_vm._v("不拘")])
                                              : _vm._l(
                                                  _vm.demandDetail
                                                    .ManpowerDemandDriverLicense,
                                                  function (item, index) {
                                                    return _c(
                                                      "span",
                                                      { key: index },
                                                      [
                                                        index > 0
                                                          ? _c("span", [
                                                              _vm._v("、"),
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(
                                                          _vm._s(
                                                            item.DriverLicense
                                                          ) + " "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                          ],
                                          2
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_c("span", [_vm._v("證照")])]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { colspan: "3" } },
                                          _vm._l(
                                            Object.keys(_vm.showCertifications),
                                            function (category) {
                                              return _c(
                                                "div",
                                                { key: category },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "mr-2" },
                                                    [_vm._v(_vm._s(category))]
                                                  ),
                                                  _vm._l(
                                                    _vm.showCertifications[
                                                      category
                                                    ],
                                                    function (item, index) {
                                                      return _c(
                                                        "span",
                                                        { key: index },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.CertificateDescription
                                                                  ? item.CertificateDescription
                                                                  : item.Certificate
                                                              ) +
                                                              " "
                                                          ),
                                                          index !==
                                                          _vm
                                                            .showCertifications[
                                                            category
                                                          ].length -
                                                            1
                                                            ? _c("span", [
                                                                _vm._v("、"),
                                                              ])
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  _c("br"),
                                                ],
                                                2
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-right",
                                            attrs: { colspan: "1" },
                                          },
                                          [_c("span", [_vm._v("其他條件")])]
                                        ),
                                        _c("td", { attrs: { colspan: "3" } }, [
                                          _c("pre", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.demandDetail.OtherConditions
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }